// import PropTypes from 'prop-types';
// import { Link as RouterLink } from 'react-router-dom';
// // @mui
// import { useTheme } from '@mui/material/styles';
// import { Box } from '@mui/material';
// import { useEffect ,useState} from 'react';

// // ----------------------------------------------------------------------

// Logo.propTypes = {
//   disabledLink: PropTypes.bool,
//   sx: PropTypes.object,
// };

// export default function Logo({ disabledLink = false}) {
//   const theme = useTheme();

//   const PRIMARY_LIGHT = theme.palette.primary.light;

//   const PRIMARY_MAIN = theme.palette.primary.main;

//   const PRIMARY_DARK = theme.palette.primary.dark;

//   const clientId = localStorage.getItem('client_id');
//   const [urls,setURL] = useState('')

//   useEffect(()=>{
//    if(clientId){
//     setURL('/static/vidisky.png')
//    }

//    else{
//     setURL('/static/vidisky23.png')
//    }
//   },[])
//   // OR
//   // const logo = <Box component="img" src={url} sx={{ width: 120, ...sx }} />
//   const logo = (
//     <Box 
//       component="img" 
//       src={urls} 
//       sx={{ 
//         marginTop: '1px',
//         width: 210, 
//         height: 'auto', 
//         display: 'block', 
//         margin: 'left',  // Center the image
//         objectFit: 'contain',  // Maintain aspect ratio
//       }} 
//     />
//   );

  

//   if (disabledLink) {
//     return <>{logo}</>;
//   }

//   // return <RouterLink to="/">{logo}</RouterLink>;
//   return <>{logo}</>;


// }


import PropTypes from 'prop-types';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import logoFull from '../assets/logo-full.png';
import logoLight from '../assets/logo-light.png';

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
  trimPadding: PropTypes.bool,
};

export default function Logo({ disabledLink = false, sx, trimPadding = false }) {
  const theme = useTheme();
  const url = theme.palette.mode === 'dark' ? logoLight : logoFull;
  //const url = theme.palette.mode === 'dark' ? '/static/logo-full.png' : '/static/logo-full.png';

  if (trimPadding) {
    // Use identical artwork and crop in both themes so its visible size stays fixed.
    return (
      <Box sx={{ position: 'relative', overflow: 'hidden', width: '100%', aspectRatio: '1916 / 490', ...sx }}>
        <Box
          component="img"
          src={logoFull}
          alt="Vidisky Logo"
          sx={{
            position: 'absolute',
            width: `${(2171 / 1916) * 100}%`,
            maxWidth: 'none',
            height: 'auto',
            left: `${(-174 / 1916) * 100}%`,
            top: `${(-120 / 490) * 100}%`,
            filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
          }}
        />
      </Box>
    );
  }

  const logo = (
    <Box
      component="img"
      src={url}
      alt="Vidisky Logo"
      sx={{
        marginTop: '1px',
        width: { xs: 200, sm: 240 },
        maxWidth: '100%',
        height: 'auto',
        display: 'block',
        objectFit: 'contain',
        ...sx,
      }}
    />
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <>{logo}</>;
}
